import { executeRequest, JFSRequest } from '@jfs/network'
import { getIdFromMap, isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const getRequestBody = (data: any) => {
  return {
    cardType: getIdFromMap(data?.cardType),
    entityId: getIdFromMap(data?.entityId),
    scheme: getIdFromMap(data?.scheme),
    status: data?.status === 'Enable',
  }
}

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const addCardMapping = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.newCardMapping),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequestBody(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { addCardMapping }
